export default function Card({ variant = 'basic', image, title, description }) {
    const base = "flex flex-col items-left p-8 rounded-lg shadow transition";
  
    const variants = {
      basic: "bg-white hover:shadow-lg",
      bordered: "bg-white border border-gray-200 hover:shadow-lg",
      colored: "bg-indigo-600 text-white hover:bg-indigo-700",
    };
  
    return (
      <div className={`${base} ${variants[variant]}`}>
        {image && <img src={image} alt={title} className="w-14 h-14 object-cover rounded-md mb-6" />}
        <h2 className="text-xl font-semibold mb-3">{title}</h2>
        <p className="text-[16px] text-left">{description}</p>
      </div>
    );
  }
  